import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import closeIcon from './icons/icon-close.svg';
import linkIcon from './icons/arrow-right.svg';

interface Props {
  text: string;
  url?: string | null;
  pageId: string;
}

const Banner: React.FC<Props> = (props: Props): JSX.Element => {
  const bannerId = `${props.pageId}_banner_closed`;
  const [bannerIsClosed, setBannerIsClosed] = useState(false);
  const { t } = useTranslation(['common']);

  function closeBanner() {
    window.sessionStorage.setItem(bannerId, 'closed');
    setBannerIsClosed(true);
  }

  useEffect(() => {
    const isClosed = window.sessionStorage.getItem(bannerId);
    setBannerIsClosed(!!isClosed);
  }, []);

  let content = <></>;
  if (!bannerIsClosed) {
    content = (
      <div className='banner bg-brandblue text-white flex justify-center p-3'>
        <div className='w-11/12 md:w-full md:flex md:justify-center md:items-center'>
          {props.url ? (
            <a
              href={props.url}
              className='flex items-center'
              target='_blank'
              rel='noreferrer'
            >
              <p>{props.text}</p>
              <img
                className='hidden md:block h-3 ml-3'
                src={linkIcon}
                alt={t('Open') ?? ''}
              />
            </a>
          ) : (
            <p>{props.text}</p>
          )}
        </div>
        <div className='h-100 w-1/12 flex justify-center items-center md:w-auto'>
          <a href='#' onClick={closeBanner}>
            <img
              className='h-3 w-auto'
              src={closeIcon}
              alt={t('Close banner') ?? ''}
            />
          </a>
        </div>
      </div>
    );
  }

  return content;
};

export default Banner;
